import {
  Card,
  Button,
  Form,
  Input,
  Select,
  Row,
  Col,
  InputNumber,
  DatePicker,
} from "antd";
import React, { useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import Notes from "../../../../../components/common/Notes";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

const NewHomeownerCreditRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Homeowner Charge", "1", "", "", "/accounting/receivables_payments/invoices/homeownercharge"),
  ]),
];

const NewHomeownerCredit = () => {
  const [homeOwner, setHomeOwner] = useState("");
  const onChange = (value) => {
    console.log(`selected ${value}`);
    setHomeOwner(value);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  return (
    <div>
      <div className="pageheading">
        <h1>New Homeowner Credit</h1>
        <div className="pageHeadingBtns">
          <button>Repeat Credit</button>
        </div>
      </div>
      <Form name="basic" autoComplete="off" layout="vertical">
        <Card>
          <Row gutter={16}>
            <Col span={9}>
              <Form.Item label="Homeowner" name="Homeowner" required>
                <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value:
                        "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                      label:
                        "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                    },
                    {
                      value:
                        "Aamir Khan (Eagle) - test1 - 912 n creek dr  edmond, OK 73034",
                      label:
                        "Aamir Khan (Eagle) - test1 - 912 n creek dr  edmond, OK 73034",
                    },
                    {
                      value:
                        "Angela S. Lamka-West, Grayson  R. Hogle - 9626 SE 4th - 9626 SE 4th  Midwest City, OK 73130",
                      label:
                        "Angela S. Lamka-West, Grayson  R. Hogle - 9626 SE 4th - 9626 SE 4th  Midwest City, OK 73130",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="Amount" required>
                <InputNumber
                  placeholder="Amount"
                  addonBefore={<FaDollarSign size={12} />}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="Credit Date" required>
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="Posting Date">
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} justify="space-between">
            <Col span={5}>
              <p>{homeOwner}</p>
            </Col>
            <Col span={15}>
              <Form.Item label="GL Account" name="GLAccount" required>
                <Select
                  showSearch
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "jack",
                      label: "Jack",
                    },
                    {
                      value: "lucy",
                      label: "Lucy",
                    },
                    {
                      value: "tom",
                      label: "Tom",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={15} offset={9}>
              <Form.Item label="Description" name="Description">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <br />
        <Row gutter={16}>
          <Col>
            <Button type="primary">Save & Add Another</Button>
          </Col>
          <Col>
            <Button>Save</Button>
          </Col>
          <Col>
            <Button type="link">Cancel</Button>
          </Col>
        </Row>
        <br />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            {/* <Notes /> */}
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </Form>
      <div className="RightSidebar">
        <RightBar RightBarData={NewHomeownerCreditRightBar} />
      </div>
    </div>
  );
};

export default NewHomeownerCredit;
